import { Suspense, lazy, useState, StrictMode, useEffect, useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { logger } from '@helpers/logger'
import { TranslationProvider } from '@providers/TranslationProvider'
import { DataProvider, DataContext } from '@providers/DataProvider'
import { PageProvider } from '@providers/PageProvider'
import ErrorBoundary from '@components/errorBoundary/ErrorBoundary'
import { PostHogProvider } from 'posthog-js/react'
import './styles/tailwind.css'
import './App.scss'
import '@styles/Scrollbars.scss'
import '@styles/Fonts.scss'
import '@styles/Svg-fonts.scss'
import '@styles/Custom.scss'
import '@styles/Firebase.scss'
import Loader from '@components/loaders/loader1/Loader'
import PropTypes from 'prop-types'

logger.log('Console Logging Enabled!')

const SignInScreenWithPreload = lazy(() => import('./pages/signInScreen/SignInScreenWithPreload'));
const MainApp = lazy(() => import('./MainApp'));

const AppRoutes = ({ user }) => {

  // Check for invite parameter in URL
  const urlParams = new URLSearchParams(window.location.search)
  const inviteParam = urlParams.get('invite')

  const golfInviteKey = urlParams.get('inviteKey')
  const golfPoolId = urlParams.get('poolId')

  console.log('INVITE_LOGS: AppRoutes - user:', !!user, 'inviteParam:', inviteParam, 'current path:', window.location.pathname)

  return (
    <BrowserRouter>
      <Suspense fallback={<Loader fadeOut={false} />}>
        <Routes>
          <Route path="/join" element={
            user ? <MainApp /> : <Navigate to={golfInviteKey ? `/signin?inviteKey=${golfInviteKey}&poolId=${golfPoolId}` : `/signin`} replace />
          } />
          <Route path="/signin" element={
            user ? <Navigate to={
              golfInviteKey ? `/join?inviteKey=${golfInviteKey}&poolId=${golfPoolId}` :
              inviteParam ? `/?invite=${inviteParam}` : "/"
            } replace /> : <SignInScreenWithPreload />
          } />
          <Route path="/*" element={
            user ? <MainApp /> : <Navigate to={inviteParam ? `/signin?invite=${inviteParam}` : "/signin"} replace />
          } />
          <Route path="*" element={
            <Navigate to={user ? (inviteParam ? `/?invite=${inviteParam}` : "/") : (inviteParam ? `/signin?invite=${inviteParam}` : "/signin")} />
          } />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

AppRoutes.propTypes = {
  user: PropTypes.any,
};

const AppContent = () => {
  const context = useContext(DataContext);

  // Show loader while checking authentication or if context is not available
  if (!context || !context.checkedAuthenticated) {
    return <Loader fadeOut={false} />;
  }

  return <AppRoutes user={context.user} />;
};

const App = () => {
  const [activePage, setActivePage] = useState(3);

  useEffect(() => {
    // Import domain-specific styles
    const domain = window.location.hostname;
    console.log("domain", domain);

    if (domain.includes('hollywood.championfan.co.za')) {
      import('@styles/domains/hollywood.scss');
    } else {
      import('@styles/Variables.scss');
    }
  }, []);

  return (
    <StrictMode>
      <ErrorBoundary>
        <PostHogProvider
          apiKey={window.app?.config?.REACT_APP_PUBLIC_POSTHOG_KEY || ''}
          options={{
            api_host: window.app?.config?.REACT_APP_PUBLIC_POSTHOG_HOST || '',
          }}
        >
          <TranslationProvider>
            <DataProvider setActivePage={setActivePage}>
              <PageProvider activePage={activePage} setActivePage={setActivePage}>
                <AppContent />
              </PageProvider>
            </DataProvider>
          </TranslationProvider>
        </PostHogProvider>
      </ErrorBoundary>
    </StrictMode>
  );
};

export default App;
